import en from './en.json';

/**
 * Message catalogues by language. Bundled eagerly: the shell's vocabulary is a
 * few kilobytes per language, and a locale switch must not flash untranslated
 * chrome while a chunk loads. Car CONTENT — names, descriptions, fun facts — is
 * a separate, per-language fetch under `/assets/content/cars/`; that is the
 * payload worth splitting, not this.
 */
const CATALOGUES = { en };

export function getCatalogue(languageCode) {
    return CATALOGUES[languageCode] || CATALOGUES.en;
}

/**
 * Look a message up. A missing key returns the key itself rather than throwing
 * or rendering blank — a visible `nav.garage` in the UI is a bug report; an
 * empty element is a silent hole.
 */
export function translate(languageCode, messageKey) {
    const catalogue = getCatalogue(languageCode);

    return Object.prototype.hasOwnProperty.call(catalogue, messageKey)
        ? catalogue[messageKey]
        : messageKey;
}

/**
 * Fill a message's `{placeholders}` from an object.
 *
 * Catalogue copy carries placeholders because word order is not ours to choose
 * — "About the {car}" reorders in most languages, so the name cannot be
 * concatenated on at the call site.
 */
export function interpolate(message, values = {}) {
    return Object.entries(values).reduce(
        (filled, [name, value]) => filled.split(`{${name}}`).join(String(value)),
        String(message),
    );
}

export { CATALOGUES };
